import { ReferenceChip } from "../reference-chip"
import type { ChatReference } from "../../types/assistant.types"

interface EntityRefUIProps {
  data: ChatReference
}

/** Inline chip rendered inside a user bubble for an order or line-item
 *  reference the user attached at compose time. The composer ships
 *  references as ``data`` parts named ``"chat_reference"``; this
 *  component is registered against that name in
 *  ``register-data-uis.tsx``. */
export function EntityRefUI({ data }: EntityRefUIProps) {
  return (
    <span className="mr-1 inline-flex align-middle">
      <ReferenceChip reference={data} inline />
    </span>
  )
}
